import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  openSnackBar(message: string, action?: string | null) {
    this.snackBar.open(message, action ?? undefined, {
      duration: 5000
    });
  }

}

